import { withdrawalActionTypes as actions } from '~client/constants/actionTypes';

export const setWithdrawalMethods = payload => ({
  type: actions.SET_WITHDRAWAL_METHODS,
  payload,
});

export const updateWithdrawalMethod = (index, payload) => ({
  type: actions.UPDATE_WITHDRAWAL,
  payload,
  index,
});

export const deleteWithdrawalMethod = index => ({
  type: actions.DELETE_WITHDRAWAL,
  index,
});

export const addWithdrawalMethod = payload => ({
  type: actions.ADD_WITHDRAWAL,
  payload,
});
